import { Icon } from "./components/icon";
import { Title } from "./components/title";
import { Base } from "./header.base";

export const Header = Object.assign(Base, {
    Title: Title,
    Icon: Icon
});
